import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/candidate_testimonials.json";

export const useTestimonials = ({ locale, filters = null, limit = null } = {}) => {
  let collection = useSourceFlowCollection(data).filter(function(item) {
    return item.region == (locale == "/us/" ? "US" : "UK");
  });

  if (filters && filters.length > 0) {
    collection = collection.filter((item) => item?.page.includes(filters));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useTestimonials;
